import axios from 'axios';
import { ApiService } from '@/shared/service/Apiservice';
import { environment } from '@/shared/enviroment/environment';

export interface TrackingHistoryEntry {
  status: string;
  timestamp: string;
  location?: string;
  notes?: string;
}

export interface DeliveryAgentInfo {
  name: string;
  phone: string;
  licenseNumber?: string;
  location?: { lat: number; lng: number };
}

export interface TrackingData {
  status: string;
  estimatedDeliveryTime?: string;
  actualDeliveryTime?: string;
  trackingHistory: TrackingHistoryEntry[];
  deliveryAgent?: DeliveryAgentInfo;
}

export interface TrackingApiResponse {
  success: boolean;
  data?: TrackingData;
  message?: string;
}

export class TrackingService {
  private apiService: ApiService;
  private apiRootServer = environment.api.apiRootServer;

  constructor(apiService?: ApiService) {
    this.apiService = apiService || new ApiService(axios.create(), this.apiRootServer);
  }

  async getTrackingInfo(orderId: string): Promise<TrackingData> {
    if (!orderId) throw new Error('orderId is required');
    const resp = await this.apiService.getRequest<TrackingApiResponse>(`tracking/${orderId}`, {}, {
      apiRoot: this.apiRootServer,
      // tracking endpoint is public, but we'll still send auth if available
    });
    if (!resp.success || !resp.data) {
      throw new Error(resp.message || 'Failed to fetch tracking info');
    }
    // Clean the trackingHistory to remove Mongoose internal fields
    const cleanTrackingHistory = resp.data.trackingHistory.map((entry: any) => ({
      status: entry.status || entry._doc?.status,
      timestamp: entry.timestamp || entry._doc?.timestamp,
      location: entry.location || entry._doc?.location,
      notes: entry.notes || entry._doc?.notes,
    }));
    return {
      ...resp.data,
      trackingHistory: cleanTrackingHistory,
    };
  }
}
